import React from 'react';

const ProfileIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12.5" height="12.5" viewBox="0 0 12.5 12.5">
    <g transform="translate(-588.368 -588.368)">
      <g transform="translate(588.368 588.368)">
        <path d="M594.618,600.868a6.231,6.231,0,1,1,2.433-.491A6.213,6.213,0,0,1,594.618,600.868Zm0-11.814a5.564,5.564,0,1,0,5.565,5.564A5.571,5.571,0,0,0,594.618,589.054Z" transform="translate(-588.368 -588.368)"/>
      </g>
      <path d="M814.449,816.687a4.979,4.979,0,0,1-8.325.027c0-.15.009-.3.016-.449a1.327,1.327,0,0,1,1-1.247q.205-.075.409-.155l.054-.021a4.149,4.149,0,0,0,1.486-.782.589.589,0,0,0,.168-.365.819.819,0,0,0-.021-.357,1.444,1.444,0,0,0-.383-.6,1.04,1.04,0,0,1-.171-.4c-.047-.149-.087-.3-.126-.452a.271.271,0,0,1,.108-.329c.022-.014.022-.087.018-.131-.03-.286-.086-.571-.089-.857a1.272,1.272,0,0,1,.189-.88.882.882,0,0,1,.259-.156,1.282,1.282,0,0,0,.288-.24.872.872,0,0,1,.321-.165l.084-.023a1.775,1.775,0,0,1,1.424.28h0a1.712,1.712,0,0,1,.809,1.4,3.87,3.87,0,0,1-.047.635c-.006.063-.017.109.053.142a.169.169,0,0,1,.082.212c-.039.165-.084.329-.118.5a.892.892,0,0,1-.142.388c-.075.1-.19.148-.261.251a1.539,1.539,0,0,0-.158.389c-.238.7.4,1.014.9,1.214s1,.429,1.5.637a1,1,0,0,1,.56.7A3.206,3.206,0,0,1,814.449,816.687Z" transform="translate(-215.654 -218.562)"/>
    </g>
  </svg>
);
export default ProfileIcon;



// WEBPACK FOOTER //
// ./src/components/Icons/ProfileIcon.js